module.exports = '1.6.0';
